import { OutlineButton, PrimaryButton } from "@components/Buttons";
import { useTheme } from "@hooks/useTheme";
import { TickUnChangedIcon } from "@components/Icons";
import useEscapeKey from "@hooks/useEscapeKey";

const UnsavedChangesModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "UNSAVED CHANGES",
  message = "The modified information has not been saved.",
  confirmText = "OK",
  cancelText = "Cancel",
  "data-testid": dataTestId = "unsaved-changes-modal",
}) => {
  const fieldValueTestId = (name) => `${dataTestId}-field-${name}-value`;
  const { colors } = useTheme();

  useEscapeKey(onClose, isOpen);

  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 ${colors.bgBlurModal} z-61 flex items-center justify-center backdrop-blur-[1px]`}
      data-testid={`${dataTestId}-overlay`}
    >
      <div className={`${colors.bgModal} rounded-lg shadow-xl max-w-md w-full mx-4`} data-testid={dataTestId}>
        {/* Modal Content */}
        <div className="p-6" data-testid={`${dataTestId}-content`}>
          {/* Icon */}
          <div className="flex justify-center mb-4" data-testid={`${dataTestId}-icon`}>
            <div className="relative">
              <TickUnChangedIcon />
            </div>
          </div>

          {/* Title */}
          <h2 className={`${colors.textPrimary} text-xl font-bold text-center mb-3 uppercase`} data-testid={`${dataTestId}-title`}>{title}</h2>

          {/* Message */}
          <div className={`${colors.textModalMessage} text-center text-sm whitespace-pre-line mb-4`} data-testid={fieldValueTestId("message")}>{message}</div>

          {/* Action Buttons */}
          <div className="flex justify-center space-x-4" data-testid={`${dataTestId}-footer`}>
            {/* Cancel Button */}
            <OutlineButton data-testid={`${dataTestId}-cancel-button`} onClick={onClose}>{cancelText}</OutlineButton>

            {/* Confirm Button */}
            <PrimaryButton data-testid={`${dataTestId}-confirm-button`} onClick={onConfirm}>{confirmText}</PrimaryButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnsavedChangesModal;
